<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/company_profile/corporate_profile.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'vision.Vision Mission & Core Value' | translate }}</p>
        </div>
        <div class="paragraph">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3">
                    <div class="card" style="border-left: 10px solid orange; margin-bottom: 40px;">
                        <h2>{{ 'vision.Vision' | translate }}</h2>
                        <p>{{ 'vision.To be the best financial institution loved by its stakeholders' | translate }}</p>
                    </div>
                    <div class="card" style="border-left: 10px solid darkblue; margin-bottom: 40px;">
                        <h2>{{ 'vision.Mission' | translate }}</h2>
                        <p>{{ 'vision.To exceed our customers’ expectations by providing a wide range of financial products/ services with competitive prices through the development of our personnel.' | translate }}</p>
                    </div>
                    <div class="card" style="border-left: 10px solid darkgreen;">
                        <h2>{{ 'vision.Core Value' | translate }}</h2>
                        <p>{{ 'vision.Our relationships with our stakeholders (our people, clients, communities, regulators and shareholders) are what differentiates NongHyup Finance (Cambodia) Plc. from our competitors. These relationships are built on six core values which serve as fundamental beliefs that we can turn to when making decisions.' | translate }}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-content">
        <div class="row no-gutters">
            <div class="col-1"></div>
            <div class="col-1">
                <img [src]="baseApiUrl + '/uploads/images/icons/humility_icon.svg'">
            </div>
            <div class="col-8">
                <h5>{{ 'vision.Humility' | translate }}</h5>
                <p>{{ 'vision.As we never know everything, we are continuously learning, sharing and widening our field of experience at every opportunity. When we see a half-full basket, we, at NH Finance, call it a half-empty basket because we know that this can only serve as a catalyst to making it full.' | translate }}</p>
            </div>
            <div class="col-2"></div>
        </div>
        <div class="row no-gutters">
            <div class="col-1"></div>
            <div class="col-1">
                <img [src]="baseApiUrl + '/uploads/images/icons/creativity_icon.svg'">
            </div>
            <div class="col-8">
                <h5>{{ 'vision.Creativity' | translate }}</h5>
                <p>{{ 'vision.Creativity is one of our most prized assets. We believe that creativity should be relevant to the needs of NH Finance and of our clients to be effective.' | translate }}</p>
            </div>
            <div class="col-2"></div>
        </div>
        <div class="row no-gutters">
            <div class="col-1"></div>
            <div class="col-1">
                <img [src]="baseApiUrl + '/uploads/images/icons/responsibility_icon.svg'">
            </div>
            <div class="col-8">
                <h5>{{ 'vision.Responsibility' | translate }}</h5>
                <p>{{ 'vision.We all share responsibility for our company as a whole and for its results. We have social and environmental responsibility and we carefully protect the positive image of our company.' | translate }}</p>
            </div>
            <div class="col-2"></div>
        </div>
        <div class="row no-gutters">
            <div class="col-1"></div>
            <div class="col-1">
                <img [src]="baseApiUrl + '/uploads/images/icons/dependibility_icon.svg'">
            </div>
            <div class="col-8">
                <h5>{{ 'vision.Dependibility' | translate }}</h5>
                <p>{{ 'vision.Dependability is honoring our words and fulfilling our promises. Our people, clients and communities deserve our respect and expert abilities. When our job, big or small, is completed, our goal is to be remembered as a dependable colleague or partner that always delivers what we promise.' | translate }}</p>
            </div>
            <div class="col-2"></div>
        </div>
        <div class="row no-gutters">
            <div class="col-1"></div>
            <div class="col-1">
                <img [src]="baseApiUrl + '/uploads/images/icons/honesty_icon.svg'">
            </div>
            <div class="col-8">
                <h5>{{ 'vision.Honesty' | translate }}</h5>
                <p>{{ 'vision.Honesty means straightforward in personal and business dealings. Dealing with cash every day, honesty is essential.' | translate }}</p>
            </div>
            <div class="col-2"></div>
        </div>
        <div class="row no-gutters">
            <div class="col-1"></div>
            <div class="col-1">
                <img [src]="baseApiUrl + '/uploads/images/icons/service_icon.svg'">
            </div>
            <div class="col-8">
                <h5>{{ 'vision.Services to People' | translate }}</h5>
                <p>{{ 'vision.Our greatness is not what we have but what we give.' | translate }}</p>
            </div>
            <div class="col-2"></div>
        </div>
    </div>
    <div class="bottom-content-poster">
        <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
        <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
    </div>
</main>